import { client } from "@/api/client";
import interceptors from "@/api/interceptor";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getConfigWd(params) {
	return client.get("user/user-balance/config-wd", {
		params: params,
	});
}

function getSaldoSummary(params) {
	return client.get("user/user-balance/summary", {
		params: params,
	});
}
function getSaldoMutasi(params) {
	return client.get("user/user-balance/data", {
		params: params,
	});
}

function getSaldoWithdraw(params) {
	return client.get("user/user-withdrawal/data", {
		params: params,
	});
}

function getWithdrawDepositReuser(params) {
	return client.get("user/user-withdrawal/data-deposit-reuser", {
		params: params,
	});
}

function requestWithdraw(params) {
	return client.post("user/user-withdrawal/request", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function requestWithdrawDepositUser(params) {
	return client.post("user/user-withdrawal/request-deposit-reuser", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function previewWithdrawDepositReuser(params) {
	return client.post("user/user-withdrawal/preview-deposit-reuser", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getSaldoSummary,
	getSaldoMutasi,
	getSaldoWithdraw,
	requestWithdraw,
	requestWithdrawDepositUser,
	previewWithdrawDepositReuser,
	getWithdrawDepositReuser,
	getConfigWd
};